import _pure from "recompose/pure";
import React from 'react';
import TableDisplaySettings from "./TableDisplaySettings";
export default _pure(function (props) {
  var disableGear = props.disableGear,
      displayPreferences = props.displayPreferences,
      updateDisplayPreferences = props.updateDisplayPreferences,
      headerRowHeight = props.headerRowHeight,
      settingsRenderer = props.settingsRenderer,
      tableMetadata = props.tableMetadata;
  if (disableGear) return null;
  return (// Add 2px to overcome row borders @artyom.fedosov
    React.createElement("div", {
      className: "nx-table__actions",
      style: {
        height: headerRowHeight + 2
      }
    }, React.createElement(TableDisplaySettings, {
      settingsRenderer: settingsRenderer,
      updateDisplayPreferences: updateDisplayPreferences,
      displayPreferences: displayPreferences,
      tableMetadata: tableMetadata
    }))
  );
});